import { Component, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateAppropriatorRequest } from '../admin-appropriators.component';

@Component({
  selector: 'app-edit-appropriator-modal',
  templateUrl: './edit-appropriator-modal.component.html',
  styleUrls: ['./edit-appropriator-modal.component.scss']
})
export class EditAppropriatorModalComponent {

  @Input() editAppName: string;
  @Input() editAppAddress: string;
  @Input() editAppPhoneNumber: string;
  @Input() editAppEmail: string;

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  editAppropriatorSubmit(_editForm: NgForm) {
    this.activeModal.close({
      name: this.editAppName,
      email: this.editAppEmail,
      address: this.editAppAddress,
      phoneNumber: this.editAppPhoneNumber,
    } as CreateAppropriatorRequest);
  }

}
